type ServiceCallWorkspaceSearch = {
  serviceCall?: boolean;
  serviceCallWorkspace?: boolean;
};

/**
 * A dedicated Service Calls route is a Jobs lens, not the ordinary removable
 * service-call filter. Preserve both facts while navigation updates the
 * surrounding Jobs search from a nested Job or Visit route.
 */
export function preserveServiceCallWorkspace<T extends ServiceCallWorkspaceSearch>(
  search: T,
  active: boolean,
): T & ServiceCallWorkspaceSearch {
  if (!active) return search;
  return {
    ...search,
    serviceCall: true,
    serviceCallWorkspace: true,
  };
}
